import slice from 'ramda/src/slice'
import length from 'ramda/src/length'

export default (startPosition, array) => {
	const len = length(array)
	const startPositionCorrected = (startPosition + len) % len
	return [...slice(startPositionCorrected, len, array), ...slice(0, startPositionCorrected, array)]
}
